/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_GeneralInputs */

const en_interview_prepare_general = /** @type {(inputs: Interview_Prepare_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const de_interview_prepare_general = /** @type {(inputs: Interview_Prepare_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemein`)
};

const fr_interview_prepare_general = /** @type {(inputs: Interview_Prepare_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Général`)
};

const es_interview_prepare_general = /** @type {(inputs: Interview_Prepare_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const it_interview_prepare_general = /** @type {(inputs: Interview_Prepare_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generale`)
};

const nl_interview_prepare_general = /** @type {(inputs: Interview_Prepare_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algemeen`)
};

const pl_interview_prepare_general = /** @type {(inputs: Interview_Prepare_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogólne`)
};

const fi_interview_prepare_general = /** @type {(inputs: Interview_Prepare_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yleinen`)
};

const da_interview_prepare_general = /** @type {(inputs: Interview_Prepare_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generel`)
};

const sv_interview_prepare_general = /** @type {(inputs: Interview_Prepare_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allmän`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Interview_Prepare_GeneralInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_general = /** @type {((inputs?: Interview_Prepare_GeneralInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_GeneralInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_general(inputs)
	if (locale === "fr") return fr_interview_prepare_general(inputs)
	if (locale === "es") return es_interview_prepare_general(inputs)
	if (locale === "it") return it_interview_prepare_general(inputs)
	if (locale === "nl") return nl_interview_prepare_general(inputs)
	if (locale === "pl") return pl_interview_prepare_general(inputs)
	if (locale === "fi") return fi_interview_prepare_general(inputs)
	if (locale === "da") return da_interview_prepare_general(inputs)
	if (locale === "sv") return sv_interview_prepare_general(inputs)
	return en_interview_prepare_general(inputs)
});